/* li-m-finder.js — MOTION-LAB 15.10.2026 · section li-m-finder. Three questions → one result card (rendered by Liquid).
   Panels share one grid cell (no height jump between questions); a tap selects, shows the ink bar for 160 ms, then advances.
   Forward = slide from the right, back = from the left (WAAPI, transform + opacity only); reduced motion = short crossfade. */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const EASE = 'cubic-bezier(.16, 1, .3, 1)', EASE_IO = 'cubic-bezier(.65, 0, .35, 1)';
  const emit = (type, detail) => {
    try { window.dispatchEvent(new CustomEvent('li:finder', { detail: Object.assign({ type }, detail) })); } catch (e) {}
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('li_finder_' + type, detail); } catch (e) {}
  };
  function pick(a) {
    if (a.q2 === 'refill') return a.q3 === 'daily' ? 'refill_l' : 'refill_s';
    if (a.q1 === 'shirt') return a.q3 === 'daily' ? 'spray_d' : 'spray';
    if (a.q1 === 'spot') return a.q3 === 'daily' ? 'bandage_d' : a.q3 === 'rare' ? 'bandage_r' : 'bandage';
    return a.q3 === 'daily' ? 'band_d' : 'band';
  }
  function setup(root) {
    const stage = root.querySelector('[data-m-fd-stage]');
    const qs = [...root.querySelectorAll('.m-fd__q')];
    const res = [...root.querySelectorAll('.m-fd__res')];
    const back = root.querySelector('[data-m-fd-back]');
    const count = root.querySelector('[data-m-fd-count]');
    const ans = {}; let cur = qs[0], step = 1, busy = false;
    root.classList.add('is-js');
    const prog = () => { root.dataset.step = step; if (count) count.textContent = Math.min(step, 3); back.hidden = step === 1; };
    function swap(from, to, dir, done) {
      to.hidden = false; to.classList.add('is-on'); to.disabled = false;
      if (to.matches('fieldset')) to.removeAttribute('disabled');
      const d = RM.matches ? 0 : 1;
      const outK = [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: `translateX(${-14 * dir * d}px)` }];
      const inK = [{ opacity: 0, transform: `translateX(${18 * dir * d}px)` }, { opacity: 1, transform: 'none' }];
      const a1 = from.animate(outK, { duration: RM.matches ? 120 : 180, easing: EASE_IO, fill: 'forwards' });
      a1.onfinish = () => {
        from.classList.remove('is-on'); a1.cancel();
        if (from.matches('fieldset')) from.setAttribute('disabled', ''); else from.hidden = true;
        to.animate(inK, { duration: RM.matches ? 160 : 380, easing: EASE });
        if (!RM.matches) to.querySelectorAll('.m-fd__opt, .m-fd__rbody > *, .m-fd__rimg').forEach((el, i) =>
          el.animate([{ opacity: 0, transform: `translateX(${10 * dir}px)` }, { opacity: 1, transform: 'none' }], { duration: 420, delay: 40 + i * 45, easing: EASE, fill: 'backwards' }));
        done && done();
      };
    }
    function focusTitle(el) { const t = el.querySelector('[data-m-fd-qt], .m-fd__rn'); if (t) t.focus({ preventScroll: true }); }
    function go(nextEl, dir) {
      if (busy) return; busy = true;
      const prev = cur; cur = nextEl;
      swap(prev, nextEl, dir, () => {
        busy = false; focusTitle(nextEl);
        const meta = root.querySelector('.m-fd__meta').getBoundingClientRect();
        const hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--h-header-sticky')) || 64;
        if (meta.top < hh || nextEl.getBoundingClientRect().bottom > innerHeight - 8) window.scrollBy({ top: meta.top - hh - 12, behavior: RM.matches ? 'auto' : 'smooth' });
      });
    }
    root.addEventListener('click', e => {
      const o = e.target.closest('.m-fd__opt');
      if (o && !busy && o.closest('.m-fd__q') === cur) {
        const q = cur.dataset.q; ans['q' + q] = o.dataset.v;
        cur.querySelectorAll('.m-fd__opt').forEach(b => { b.classList.toggle('is-sel', b === o); b.setAttribute('aria-pressed', b === o ? 'true' : 'false'); });
        emit('step', { step: +q, answers: Object.assign({}, ans) });
        setTimeout(() => {
          if (q === '3') {
            const key = pick(ans); const r = res.find(x => x.dataset.r === key) || res[0];
            r.querySelectorAll('img[loading="lazy"]').forEach(i => { i.loading = 'eager'; });
            step = 4; prog(); go(r, 1); emit('result', { key, answers: Object.assign({}, ans) });
          } else { step = +q + 1; prog(); go(qs[+q], 1); }
        }, RM.matches ? 60 : 170);
        return;
      }
      if (e.target.closest('[data-m-fd-back]') && !busy && step > 1) {
        step = step === 4 ? 3 : step - 1; prog(); go(qs[step - 1], -1); return;
      }
      if (e.target.closest('[data-m-fd-again]') && !busy) {
        Object.keys(ans).forEach(k => delete ans[k]);
        root.querySelectorAll('.m-fd__opt').forEach(b => { b.classList.remove('is-sel'); b.setAttribute('aria-pressed', 'false'); });
        step = 1; prog(); go(qs[0], -1); emit('restart', {}); return;
      }
      const add = e.target.closest('[data-m-fd-add][data-li-add]');
      if (add) emit('add', { key: cur.dataset.r, variant: add.dataset.liAdd, answers: Object.assign({}, ans) });
    });
    // preload the three most likely result images once the last question is on screen
    root.querySelectorAll('.m-fd__opt').forEach(b => b.setAttribute('aria-pressed', 'false'));
    prog();
  }
  document.querySelectorAll('[data-m-fd]').forEach(setup);
})();
